import { createMatchSelector, LOCATION_CHANGE } from 'connected-react-router';
import { Base64 } from 'js-base64';
import { createMiddleware } from '../../../shared/redux';
import { redirectToHome, redirectToSignIn } from '../auth-base-state';
import {
    CONFIRM_INVITE_NOT_LOGGED_USER_EXCEPTION_RAISED,
    CONFIRM_INVITE_REQUEST_SUCCEEDED,
    raiseConfirmInviteNotLoggedUserException,
    requestConfirmInvite,
} from './confirm-invite-state';
import { acceptSignIn, setSignInFlags, signIn } from '../sign-in/sign-in.state';
import { ROUTES } from '../auth.constants';
import * as AuthService from '../auth-service';
import { showErrorToast } from '../../../shared/toasts/toasts.state';
import Routes from '../../router/routes.constants';

export const confirmInviteMiddleware = createMiddleware({
    [LOCATION_CHANGE]: (state) => {
        const matchSelector = createMatchSelector(ROUTES.CONFIRM_INVITE);
        const match = matchSelector(state);

        if (!match) return [];

        const { params } = match;
        const { token, username: encodedUsername } = params;
        const username = Base64.decode(encodedUsername);

        return AuthService.currentAuthenticatedUser()
            .then((user) => {
                const { username: loggedUsername } = user;
                const isOwnerOfInvite = loggedUsername === username;

                return isOwnerOfInvite ? requestConfirmInvite()
                    : raiseConfirmInviteNotLoggedUserException({
                        error: 'This invite does not belongs to current user',
                    });
            }).catch(() => (token
                ? [
                    setSignInFlags({ fromInvite: true, newUser: true }),
                    signIn({ username, password: token }),
                ]
                : [
                    setSignInFlags({ fromInvite: true }),
                    redirectToSignIn(),
                ]
            ));
    },
    [CONFIRM_INVITE_REQUEST_SUCCEEDED]: () => acceptSignIn({ landingRoute: Routes.HOME }),
    [CONFIRM_INVITE_NOT_LOGGED_USER_EXCEPTION_RAISED]: state => [
        redirectToHome(),
        showErrorToast({ message: state.auth.confirmInvite.error }),
    ],
});
